<template>
  <div class="tradingview-widget-containerss">
    <div class="tradingview-widget-container__widget"></div>
    <div class="tradingview-widget-copyright"></div>
  </div>
</template>

<script>
export default {
  mounted() {
    let container3 = document.getElementsByClassName(
      "tradingview-widget-containerss"
    )[0];
    container3.replaceChildren();
    const script3 = document.createElement("script");
    script3.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-stock-heatmap.js";
    script3.type = "text/javascript";
    script3.async = true;
    script3.innerHTML = JSON.stringify({
      exchanges: [],
      dataSource: "SENSEX",
      grouping: "sector",
      blockSize: "market_cap_basic",
      blockColor: "change",
      locale: "in",
      symbolUrl: "",
      colorTheme: "light",
      hasTopBar: false,
      isDataSetEnabled: true,
      isZoomEnabled: true,
      hasSymbolTooltip: false,
      width: "100%",
      height: "600",
    });
    console.log(container3);
    container3.appendChild(script3);
  },
};
</script>

<style lang="scss" scoped></style>
